// extracted by mini-css-extract-plugin
module.exports = {"admitted":"ApplicantsTab_admitted__2zgBt"};